import { render, staticRenderFns } from "./ActivitiesOverviewFreeCoinsCampaigns.vue?vue&type=template&id=4842da2c&scoped=true&"
import script from "./ActivitiesOverviewFreeCoinsCampaigns.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesOverviewFreeCoinsCampaigns.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesOverviewFreeCoinsCampaigns.vue?vue&type=style&index=0&id=4842da2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842da2c",
  null
  
)

export default component.exports